/**
 * Extra tab buttons + panels for the external recording HTML document (non-React).
 * Shown only when Corti / transcript results tabs are enabled (!hideResultsTab).
 *
 * Stage 1b of the diff-review redesign (Leejoe 2026-06-22) hid the A&P / Scores
 * / Orders sub-tabs from the recorder popup. The recorder now keeps:
 *   - Live Transcript view (rendered elsewhere)
 *   - SOAP Note view (the A6 template-fill SOAP — kept here as the only
 *     clinical-results tab the popup exposes)
 *   - "Process this recording" button (in the SOAP Note tab, hands off to
 *     Process Forms in the chart for diff application)
 *
 * Brett's structured-payload code paths (renderApTabFromTemplate,
 * renderScoresTabFromTemplate, renderOrdersTabFromTemplate, render*FromLlm,
 * etc.) are PRESERVED in useExternalRecording.js. They no-op on missing DOM
 * (every renderer guards with `if (!el) return`). Re-emit the tabs by
 * passing `{ includeLegacy: true }` to either function below to revive
 * Brett's A&P / Scores / Orders sub-tabs instantly.
 */

const LEGACY_TAB_BUTTONS = `
            <button class="tab-btn" id="tab-ap" onclick="switchTab('ap')" title="Problem-based assessment & plan with ICD-10-style problem names">A&amp;P</button>
            <button class="tab-btn" id="tab-scores" onclick="switchTab('scores')">Scores</button>
            <button class="tab-btn" id="tab-orders" onclick="switchTab('orders')" title="Orders to enter (labs, imaging, referrals, prescriptions, follow-up) — handoff to remote-team entry">Orders</button>`;

const SOAP_TAB_BUTTON = `
            <button class="tab-btn" id="tab-report" onclick="switchTab('report')" title="Full SOAP note compiled from AI template-fill">SOAP Note</button>`;

export function getClinicalResultsTabButtonsHtml({ includeLegacy = false } = {}) {
  return (includeLegacy ? LEGACY_TAB_BUTTONS : '') + SOAP_TAB_BUTTON;
}

const PLACEHOLDER =
  '<p style="color:#718096;font-style:italic;margin:0;">Content appears here after transcription completes.</p>';

const LEGACY_TAB_PANELS = `
        <div id="apTab" class="tab-content" style="padding: 1rem; overflow-y: auto;">
            <div id="apTabContent">${PLACEHOLDER}</div>
        </div>
        <div id="scoresTab" class="tab-content" style="padding: 1rem; overflow-y: auto;">
            <div id="scoresTabContent">${PLACEHOLDER}</div>
        </div>
        <div id="ordersTab" class="tab-content" style="padding: 1rem; overflow-y: auto;">
            <div id="ordersTabContent">${PLACEHOLDER}</div>
        </div>`;

const SOAP_TAB_PANEL = `
        <div id="reportTab" class="tab-content" style="padding: 1rem; overflow-y: auto;">
            <div id="reportTabContent">${PLACEHOLDER}</div>
        </div>`;

export function getClinicalResultsTabPanelsHtml({ includeLegacy = false } = {}) {
  return (includeLegacy ? LEGACY_TAB_PANELS : '') + SOAP_TAB_PANEL;
}
